import { useRef } from 'react';

import SoundWave from '../SoundWave/SoundWave';

import './MusicPreview.css'

export default function MusicPreview(props) {
    const audioRef = useRef();

    return (<tr className="music-preview">
        <td>
            <div className="music-title">{props.title}</div>
        </td>
        <td>
            <audio ref={audioRef} src={props.audioFile} controls></audio>
        </td>
        <td className="sound-wave-container">
            <SoundWave stopWhenPaused vid={audioRef} color="white" waveDataUrl={props.waveDataUrl}></SoundWave>
        </td>
    </tr>)
}